const draftSavers = new Set<() => Promise<boolean>>();

export function hasPendingWorkflowDrafts() { return draftSavers.size > 0; }

export function registerDraftSaver(save: () => Promise<boolean>) {
  draftSavers.add(save);
  return () => { draftSavers.delete(save); };
}

export async function flushWorkflowDrafts(): Promise<boolean> {
  for (const save of [...draftSavers]) {
    try { if (!await save()) return false; } catch { return false; }
  }
  return true;
}
